import { Box } from "@mui/material";
import type { ComponentProps, ComponentType } from "react";
import styled from "styled-components";

type BoxComponent = ComponentType<ComponentProps<typeof Box>>;

export const StyledIndexCardsContainer: BoxComponent = styled(Box)`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  width: 100%;
  gap: 16px;
`;

export const StyledIndexCard: BoxComponent = styled(Box)`
  display: flex;
  flex: 1;
  width: 100%;

  @media (min-width: 700px) {
    min-width: 100%;
  }

  @media (min-width: 990px) {
    min-width: 45%;
  }

  @media (min-width: 1921px) {
    min-width: 25%;
  }
`;
